<div class="dropdown-wrapper" [class.disabled]="disabled()">
  <div class="toggle" (mousedown)="toggle()" #toggleRef>
    <ng-content></ng-content>
  </div>
  @if (openState()) {
    <div
      class="dropdown"
      [class.dropup]="dropUp()"
      [class.right]="alignment() === 'right'"
      [class.left]="alignment() !== 'right'"
      [class.autowidth]="autowidth()"
      (clickOutside)="openState() ? close() : null"
      (click)="openState() && closeOnClick() ? close() : null"
      (@fadeInOutDropdownComponent.start)="onDropdownAnimationStart($event)"
      (@fadeInOutDropdownComponent.done)="onDropdownAnimationDone($event)"
      @fadeInOutDropdownComponent
      #dropdownElement
    >
      <ng-container [ngTemplateOutlet]="dropdown()"></ng-container>
    </div>
  }
</div>
